export class ResearcherTaskList {
  calculatedValue: number;
  currentSysDt: string;
  crrsrCount: number; // count(CR_RequestSpecialRetrieve)
  dataType1: string;
  dataType2: string;
  dataType3: string;
  detailWork: string; // request type
  displayNumber: number;
  emailAddress: string; // aka sourceEmail
  errorDescription: string; // aka error
  filterText: string; // used to calculate filter total
  filterTotal: number; // count(CR_RequestSpecialRetrieve[@jurisdictionId = $filterText])
  fullName: string; // RefName: string;
  gisUserName: string; // userName;
  lateTotal: number; // aka lateRequests
  max: number; // aka MaxWork
  min: number; // aka MinWork
  newTotal: number;   // aka newRequests....maxNewRequest
  numbers: number;
  requestTotal: number; // totalRequests... requests
  sortOne: string; // Jurisdiction
  sortTwo: string; // iso_RequestDt
  sortThree: string; // CaseNbr
  sortOrder1: string; // ascending
  sortOrder2: string; // descending
  sortOrder3: string; // ascending
  sourceName: string;
  sourceType: string;
  sysID: string; // aka reportNbr
  totalDisplayRequest: number; // *
}



// WEBPACK FOOTER //
// ./src/models/researcherTaskList.ts